import { Route, Routes } from 'react-router-dom';
import authRoutes from './authRoutes';
import CustomRouter from '../utils/CustomRouter';
import history from '../utils/history';
import dashboardRoutes from './dashboardRoutes';
import NotFound from '../pages/NotFound';

const AppRoutes = () => (
  <CustomRouter history={history}>
    <Routes>
      {authRoutes}
      {dashboardRoutes}
      <Route path="*" element={<NotFound/>}/>
    </Routes>
  </CustomRouter>
);

export default AppRoutes;
